/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { CursorManager } from '../../../../core/navigation';
import { NetworkManager } from '../../../../core/network/NetworkManager';
import { showUserPreferencesScreen } from '../../../screens/screens.reducers';
import {
    setMyShowsOptionsFocusedIndexAction,
    setMyShowsUserSettingsErrorAction,
} from './myshowsoptionsmenu.actions';
import { setMyShowsUserSettings } from './myshowsoptionsmenu.reducers';

export const onKeyBackMyShowsOptionsMenu = () => (dispatch: Function) => {
    dispatch(showUserPreferencesScreen());

    if (NetworkManager.isNetworkDisconnected()) {
        dispatch(setMyShowsUserSettingsErrorAction(true));
    }
};

export const onKeyUpMyShowsOptionsMenu = () => (dispatch: Function, getState: Function) => {
    if (!isPageValidForKeyHandlers(getState)) return;

    const { focusedOptionIndex } = getState().myShowsUserSettings;

    const nextIndex = focusedOptionIndex - 1 < 0 ? 0 : focusedOptionIndex - 1;
    dispatch(setMyShowsOptionsFocusedIndexAction(nextIndex, true));
};

export const onKeyDownMyShowsOptionsMenu = () => (dispatch: Function, getState: Function) => {
    if (!isPageValidForKeyHandlers(getState)) return;
    const { focusedOptionIndex, settingsOptions } = getState().myShowsUserSettings;

    const maxIndex = settingsOptions.myShowsOrders.length - 1;
    const nextIndex = focusedOptionIndex + 1 < maxIndex ? focusedOptionIndex + 1 : maxIndex;
    dispatch(setMyShowsOptionsFocusedIndexAction(nextIndex, true));
};

export const onKeyOkMyShowsOptionsMenu = () => async (dispatch: Function, getState: Function) => {
    if (!isPageValidForKeyHandlers(getState)) return;
    const { focusedOptionIndex, settingsOptions, hasError } = getState().myShowsUserSettings;
    const selectedOption = settingsOptions.myShowsOrders[focusedOptionIndex].value;

    await dispatch(setMyShowsUserSettings(selectedOption, hasError));
    dispatch(onKeyBackMyShowsOptionsMenu());
};

export const onMouseOverMyShowsOptions = () => (dispatch: Function, getState: Function) => {
    if (!isPageValidForKeyHandlers(getState)) return;
    const { value } = getState().inputFactory;
    const { focusedOptionIndex } = getState().myShowsUserSettings;

    const position = Number(value.split('-')[0]);
    const newIndex = Number.isNaN(position) ? focusedOptionIndex : position;

    dispatch(setMyShowsOptionsFocusedIndexAction(newIndex, true));
};

export const onMouseOutMyShowsOptions = () => (dispatch: Function, getState: Function) => {
    if (!isPageValidForKeyHandlers(getState)) return;
    const { focusedOptionIndex } = getState().myShowsUserSettings;

    dispatch(setMyShowsOptionsFocusedIndexAction(focusedOptionIndex, false));
};

export const onCursorStateChangeMyShowsOptions = () => (dispatch: Function, getState: Function) => {
    if (!isPageValidForKeyHandlers(getState)) return;
    const { focusedOptionIndex } = getState().myShowsUserSettings;

    if (CursorManager.isCursorAppeared()) {
        dispatch(setMyShowsOptionsFocusedIndexAction(focusedOptionIndex, true));
    } else {
        dispatch(setMyShowsOptionsFocusedIndexAction(focusedOptionIndex, false));
    }
};

const isPageValidForKeyHandlers = (getState: Function) => {
    if (getState().userPreferences.hasOnePassOrMyShowsGetApiError) return false;

    const { settingsOptions, settingsValues } = getState().myShowsUserSettings;
    if (settingsOptions === undefined || settingsValues === undefined) return false;

    return true;
};
